/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { useAdaptiveModeContext as d } from "../contexts/AdaptiveModeContext.mjs";
const p = (t) => e.forwardRef((o, a) => {
  const r = d();
  return /* @__PURE__ */ e.createElement(t, { ...o, ref: a, _adaptiveMode: r });
});
export {
  p as withAdaptiveModeContext
};
